import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'circle-rectangle', 'CircleRectangle', [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"}],["path",{"d":"M7 10h10v4h-10l0 -4"}]]);